export default {
    init() {
        if ($('[data-testimonials]').length) {
            $('[data-testimonials]').each(function () {
                const slider = $(this).find('[data-testimonial-slider]')
                const next = $(this).find('[data-slider*="next"]')
                const prev = $(this).find('[data-slider*="prev"]')

                slider.slick({
                    arrows: true,
                    fade: false,
                    infinite: true,
                    speed: 300,
                    draggable: false,
                    slidesToShow: 1,
                    nextArrow: next,
                    prevArrow: prev,
                })

                let height = $(this).find('.slick-track').height()
                $(this).find('.slick-slide figure').css('height', `${height}px`)
            })
        }
    },
}
